import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api"; // Axios instance
import AdminNavbar from "./AdminNavbar";
import Toast from "./Toast";

export default function BannerForm({ onLogout }) {
  const navigate = useNavigate();
  const { id } = useParams(); // For edit mode
  const isEdit = !!id;

  const [welcomeText, setWelcomeText] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [currentImage, setCurrentImage] = useState(null); // For edit preview
  const [toast, setToast] = useState(null);

  // Load existing banner if editing
  useEffect(() => {
    if (isEdit) {
      api
        .get(`/banners.php`) // fetch all banners
        .then((res) => {
          const banner = res.data.find((b) => b.id === parseInt(id));
          if (banner) {
            setWelcomeText(banner.welcome_text || "");
            setTitle(banner.title || "");
            setDescription(banner.description || "");
            setCurrentImage(banner.image_url);
          } else {
            setToast({ message: "Banner not found", type: "error" });
          }
        })
        .catch(() => setToast({ message: "Server error", type: "error" }));
    }
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !welcomeText) {
      setToast({ message: "Title and Welcome Text required", type: "error" });
      return;
    }

    const formData = new FormData();
    formData.append("welcome_text", welcomeText);
    formData.append("title", title);
    formData.append("description", description);
    if (image) formData.append("image", image);
    if (isEdit) formData.append("id", id);

    try {
      const endpoint = isEdit ? "/update_banner.php" : "/add_banner.php";
      const res = await api.post(endpoint, formData);
      if (res.data.success) {
        setToast({ message: res.data.message, type: "success" });
        setTimeout(() => navigate("/admin/banners"), 1000);
      } else {
        setToast({ message: res.data.message, type: "error" });
      }
    } catch {
      setToast({ message: "Server error", type: "error" });
    }
  };

  return (
    <>
      <AdminNavbar onLogout={onLogout} />
      <div className="container mt-5" style={{ maxWidth: 600 }}>
        <div className="card shadow">
          <div className="card-body">
            <h3 className="card-title mb-4">
              {isEdit ? "Edit Banner" : "Add Banner"}
            </h3>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="mb-3">
                <label className="form-label">Welcome Text</label>
                <input
                  type="text"
                  className="form-control"
                  value={welcomeText}
                  onChange={(e) => setWelcomeText(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setImage(e.target.files[0])}
                  accept="image/*"
                />
                {currentImage && !image && (
                  <img
                    src={currentImage}
                    alt="Current"
                    width="200"
                    className="mt-2"
                  />
                )}
              </div>

              <button className="btn btn-success w-100" type="submit">
                {isEdit ? "Update Banner" : "Add Banner"}
              </button>
            </form>
          </div>
        </div>
      </div>

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
}
